import { Badge } from 'components/ui/badge';
import { Button } from 'components/ui/button';
import CloseCross from 'components/Icons/CloseCross';
import { Label } from 'components/ui/label';
import { ApiData } from 'interfaces/api';
import { Tag } from 'interfaces/tag';
import { FC, useMemo, useState } from 'react';

interface TagsFilterProp {
  onChange: (selectedTagIds: number[]) => void;
  tags: ApiData<Tag>[];
}

export const TagsFilter: FC<TagsFilterProp> = ({
  onChange,
  tags: response,
}) => {
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);
  const tags = useMemo(() => {
    return (
      response?.filter((tag) => selectedTagIds.indexOf(tag.id) === -1) || []
    );
  }, [selectedTagIds, response]);

  const selectedTags = useMemo(() => {
    return (
      response?.filter((tag) => {
        return selectedTagIds.indexOf(tag.id) !== -1;
      }) || []
    );
  }, [selectedTagIds, response]);

  const handleAddTag = (tagId: number) => {
    setSelectedTagIds([...selectedTagIds, tagId]);
    onChange([...selectedTagIds, tagId]);
  };

  const handleRemoveTag = (tagId: number) => {
    const newSelectedTagIds = selectedTagIds.filter((id) => id !== tagId);
    setSelectedTagIds(newSelectedTagIds);
    onChange(newSelectedTagIds);
  };

  const reset = () => {
    setSelectedTagIds([]);
    onChange([]);
  };

  return (
    <div className="lg:max-w-sm">
      <div>
        {selectedTagIds.length > 0 && (
          <div className="flex justify-between">
            <Label htmlFor="Nom" className="text-base flex self-center">
              Filtres
            </Label>
            <Button
              type="button"
              color="transparent"
              className="text-base"
              data-testid="clear-tags-filter"
              onClick={reset}
            >
              Effacer tout
            </Button>
          </div>
        )}

        <div data-testid="selected-tags-filter">
          {selectedTags.map((tag) => {
            return (
              <Badge
                asChild
                key={tag.id}
                className="inline-flex w-max cursor-pointer items-center rounded-full border border-gray-300 bg-gray-600 px-4 py-2 text-sm font-semibold text-gray-200 transition duration-300 ease-in-out active:bg-gray-500"
              >
                <button
                  type="button"
                  onClick={() => handleRemoveTag(tag.id)}
                  className="inline-flex items-center gap-2"
                >
                  <span>{tag.name}</span>
                  <CloseCross />
                </button>
              </Badge>
            );
          })}
        </div>
      </div>

      <div>
        <div className="my-3">
          {tags.map((tag: ApiData<Tag>) => {
            return (
              <Badge
                asChild
                key={tag.id}
                className="inline-flex w-max cursor-pointer items-center rounded-full bg-gray-200 px-3 py-1 text-sm font-semibold text-gray-700 transition duration-300 ease-in-out hover:bg-gray-300 mr-2 mb-2 lg:block"
              >
                <button
                  type="button"
                  onClick={() => handleAddTag(tag.id)}
                  className="inline-flex items-center gap-2"
                >
                  <span>{tag.name}</span>
                  <span className="inline-flex h-6 w-6 items-center justify-center rounded-full border bg-white text-black">
                    {tag.count}
                  </span>
                </button>
              </Badge>
            );
          })}
        </div>
      </div>
    </div>
  );
};
